let db;
let isDBInitialized = false;
let dbRetryCount = 0;
const MAX_RETRIES = 3;
let lastSavedContent = '';



let simulateIndexedDBFailure = false;  // set this to true for testing with local storage




function initIndexedDB() {
    if (simulateIndexedDBFailure || !('indexedDB' in self)) {
        console.log('IndexedDB is not supported in this browser.');
        isDBInitialized = false;
        self.postMessage({ type: 'db_error', message: 'IndexedDB is not supported in this browser.' });
        return;
    }

    console.log('Initializing IndexedDB...');
    const request = indexedDB.open('EditorStorageDB', 1);

    request.onerror = (event) => {
        console.log('Error opening IndexedDB', event.target.errorCode);
        self.postMessage({ type: 'db_error', message: 'Error opening IndexedDB', error: event.target.errorCode });
        isDBInitialized = false;
    };

    request.onsuccess = (event) => {
        db = event.target.result;
        console.log('IndexedDB initialized successfully.');
        isDBInitialized = true;
    };

    request.onupgradeneeded = (event) => {
        db = event.target.result;
        if (!db.objectStoreNames.contains('files')) {
            db.createObjectStore('files', { keyPath: 'key' });
            console.log('Object store "files" created.');
        }
    };
}

// Close the IndexedDB connection
function closeDatabase() {
    if (db) {
        db.close();
        db = null;
        console.log('IndexedDB connection closed.');
    }
}

function ensureDBInitialized(actionCallback, fallbackCallback) {
    if (!('indexedDB' in self)) {
        console.log('IndexedDB is not supported in this browser.');
        fallbackCallback();
        return;
    }

    if (isDBInitialized && db) {
        actionCallback();
    } else if (dbRetryCount < MAX_RETRIES) {
        dbRetryCount++;
        console.log(`Database not initialized. Retrying (${dbRetryCount}/${MAX_RETRIES}) in 100ms...`);
        setTimeout(() => ensureDBInitialized(actionCallback, fallbackCallback), 100);
    } else {
        console.log('Maximum retry attempts reached. Assuming IndexedDB is not supported.');
        fallbackCallback();
    }
}



// Calculate the size of the cleaned content
function getContentSize(contentBuffer) {
    return contentBuffer.byteLength / 1024;  // Returns size in KB
}



function saveContentToIndexedDB(id, filename, contentBuffer) {
    const contentSize = getContentSize(contentBuffer);
    console.log('Content size is:', contentSize, 'KB');

    if (contentSize > 1000) {
        console.error('Content size exceeds 1000KB limit');
        self.postMessage({ id, status: 'error', message: 'Content size exceeds 1000KB limit' });
        return;
    }

    ensureDBInitialized(
        () => {
            const key = `editor-${filename}`;
            const txn = db.transaction(['files'], 'readwrite');
            const store = txn.objectStore('files');
            const now = new Date().toISOString();

            const getRequest = store.get(key);

            getRequest.onerror = (event) => {
                console.error('Error accessing IndexedDB during save', event.target.errorCode);
                self.postMessage({ id, status: 'db_error', message: 'Error accessing IndexedDB during save', error: event.target.errorCode });
            };

            getRequest.onsuccess = () => {
                const existingEntry = getRequest.result;
                const entry = {
                    key,
                    content: contentBuffer, // Store ArrayBuffer directly
                    createdTime: existingEntry ? existingEntry.createdTime : now,
                    lastUpdated: now
                };

                const putRequest = store.put(entry);

                putRequest.onerror = (event) => {
                    console.error('Error saving content', event.target.errorCode);
                    self.postMessage({ id, status: 'db_error', message: 'Error saving content', error: event.target.errorCode });
                };

                putRequest.onsuccess = () => {
                    //console.log(`Content saved successfully for key: ${key}`);
                    self.postMessage({ id, status: 'saved', key, lastUpdated: now });
                };
            };
        },
        () => {
            // Handle LocalStorage fallback if IndexedDB is not available
            if (contentSize > 500) {
                console.error('Content size exceeds 500KB limit for LocalStorage');
                self.postMessage({ id, status: 'error', message: 'Content size exceeds 500KB limit for LocalStorage' });
                return;
            }
            self.postMessage({
                id,
                action: 'saveToLocalStorage',
                data: { filename, content: contentBuffer }
            });
        }
    );
}


function getContentFromIndexedDB(id, filename) {
    ensureDBInitialized(
        () => {
            const key = `editor-${filename}`;
            const txn = db.transaction(['files'], 'readonly');
            const store = txn.objectStore('files');

            const request = store.get(key);

            request.onerror = (event) => {
                console.log('Error retrieving content', event.target.errorCode);
                self.postMessage({ id, status: 'db_error', message: 'Error retrieving content', error: event.target.errorCode });
            };

            request.onsuccess = () => {
                const file = request.result;
                if (file && file.content instanceof ArrayBuffer) {
                    console.log(`Content retrieved for key: ${key}`);
                    // Transfer the ArrayBuffer ownership to the main thread
                    self.postMessage(
                        { id, status: 'retrieved', key: file.key, content: file.content, lastUpdated: file.lastUpdated },
                        [file.content]
                    );
                } else {
                    console.log(`Content not found for key: ${key}`);
                    self.postMessage({ id, status: 'not_found', key });
                }
            };
        },
        () => {
            // If IndexedDB is unavailable, request content from localStorage
            self.postMessage({
                id,
                action: 'getFromLocalStorage',
                data: { filename }
            });
        }
    );
}


// Delete Content from IndexedDB
function deleteContentFromIndexedDB(id, filename) {
    ensureDBInitialized(
        () => {
            const key = `editor-${filename}.html`;
            const txn = db.transaction(['files'], 'readwrite');
            const store = txn.objectStore('files');

            const deleteRequest = store.delete(key);

            deleteRequest.onerror = (event) => {
                console.log('Error deleting content', event.target.errorCode);
                self.postMessage({ id, status: 'db_error', message: 'Error deleting content', error: event.target.errorCode });
            };

            deleteRequest.onsuccess = () => {
                console.log(`Content deleted for key: ${key}`);
                self.postMessage({ id, status: 'deleted', key });
            };
        },
        () => {
            // If IndexedDB isn't available, send a request to the main thread to delete from localStorage
            self.postMessage({
                id,
                action: 'deleteFromLocalStorage',
                data: { filename }
            });
        }
    );
}

function renameFileInIndexedDB(id, oldFilename, newFilename) {
    ensureDBInitialized(
        () => {
            const oldKey = `editor-${oldFilename}`;
            const newKey = `editor-${newFilename}`;
            const txn = db.transaction(['files'], 'readwrite');
            const store = txn.objectStore('files');

            // Retrieve the existing record
            const getRequest = store.get(oldKey);

            getRequest.onerror = (event) => {
                console.error('Error retrieving content during rename', event.target.errorCode);
                self.postMessage({ id, status: 'db_error', message: 'Error retrieving content during rename', error: event.target.errorCode });
            };

            getRequest.onsuccess = () => {
                const record = getRequest.result;
                if (record) {
                    // Delete the original record
                    const deleteRequest = store.delete(oldKey);
                    deleteRequest.onerror = (event) => {
                        console.error('Error deleting original content during rename', event.target.errorCode);
                        self.postMessage({ id, status: 'db_error', message: 'Error deleting original content during rename', error: event.target.errorCode });
                    };

                    deleteRequest.onsuccess = () => {
                        // Update the key and save the record with the new filename
                        record.key = newKey;
                        const putRequest = store.put(record);
                        putRequest.onerror = (event) => {
                            console.error('Error saving content with new filename', event.target.errorCode);
                            self.postMessage({ id, status: 'db_error', message: 'Error saving content with new filename', error: event.target.errorCode });
                        };

                        putRequest.onsuccess = () => {
                            console.log(`Content renamed successfully from ${oldKey} to ${newKey}`);
                            self.postMessage({ id, status: 'renamed', oldKey, newKey });
                        };
                    };
                } else {
                    console.log(`Content not found for key: ${oldKey}`);
                    self.postMessage({ id, status: 'not_found', key: oldKey });
                }
            };
        },
        () => {
            // If IndexedDB isn't available, send a request to the main thread to delete from localStorage
            self.postMessage({
                id,
                action: 'renameInLocalStorage',
                data: { oldFilename, newFilename }
            });
        }
    );
}


// Process Content Before Returning or Saving
function processContent(content) {
    if (!content.toLowerCase().includes('doctype html')) {
        content = '<!DOCTYPE html>' + content;
    }

    const patternsAndReplacements = [
        { pattern: /<link[^>]+tinymce\/skins[^>]+>/g, replacement: "" },
        { pattern: /element-selected/g, replacement: '' },
        { pattern: /builder-outline-move-hook/g, replacement: '' },
        { pattern: /builder-outline-blue/g, replacement: '' },
        { pattern: /builder-outline-selected-controls/g, replacement: '' },
        { pattern: /<link([^>]+)builder\-helper([^>]+)>/ig, replacement: '' },
        { pattern: /<script([^>]+)builder\-helper([^>]+)>\<\/script>/ig, replacement: '' },
        { pattern: /\b(drag-indicator|drop-indicator|highlight|draggable|drop-highlight|invalid-drop|cancel-button)\b/g, replacement: '' },
        { pattern: /<div[^>]*id=["']caretMarker["'][^>]*>.*?<\/div>/ig, replacement: '' },
        { pattern: /<div id=\"PageElement([\s\S]*?)display: none;\">/gm, replacement: "<div id=\"PageElement\" class=\"page-element\" aria-hidden=\"true\" >" },
        { pattern: /<div role=\"application\" class=\"tox([\s\S]*?)style=\"position: relative;\">/gm, replacement: '' },
        { pattern: /<div tabindex=\"-1\" class=\"tox-dialog-wrap\">([\s\S]*?)class=\"tox-button\">Save<\/button><\/div><\/div><\/div><\/div><\/div>/gm, replacement: '' },
        { pattern: /<span class="tick-slider-tick"><\/span>/gm, replacement: '' },
        { pattern: /<span style="font-size: var\(--lefttdfontsize\);">&nbsp;<\/span><br><\/h3>/gm, replacement: `</h3>\n<span style="height: 0px; display: flex">&nbsp;</span>` },
        { pattern: /<div[^>]*class="tox[^"]*"[^>]*>[\s\S]*?<\/div>/gm, replacement: '' },
        { pattern: /(<div class="footer-space"><\/div>\s*<\/div>\s*<\/div>\s*<\/td>\s*<\/tr>\s*<\/tfoot>)[\s\S]*/gm, replacement: `$1\n</table></div></div></body></html>` },
        { pattern: /<a[^>]*class=["']use-template-link["'][^>]*>[\s\S]*?<\/a>/gi, replacement: '' },
        { pattern: /<button[^>]*class=["']use-template-btn["'][^>]*>[\s\S]*?<\/button>/gi, replacement: '' },
        { pattern: /data-mce-style="[^"]*"/gi, replacement: '' }
    ];

    patternsAndReplacements.forEach(({ pattern, replacement }) => {
        content = content.replace(pattern, replacement);
    });

    return content;
}

// Fast Hash Function (FNV-1a Variant)
function fastHash(str) {
    let hash = 2166136261;  // FNV-1a Prime
    for (let i = 0; i < str.length; i++) {
        hash ^= str.charCodeAt(i);
        hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return hash >>> 0;  // Convert to 32-bit unsigned integer
}

function findTextDifferences(oldText, newText) {
    let minLength = Math.min(oldText.length, newText.length);
    let differences = [];

    for (let i = 0; i < minLength; i++) {
        if (oldText[i] !== newText[i]) {
            differences.push(`🔺 Difference at position ${i}: '${oldText[i] || "[empty]"}' → '${newText[i] || "[empty]"}'`);
        }
    }

    // Check if new text has extra characters
    if (newText.length > oldText.length) {
        differences.push(`➕ Added: '${newText.slice(oldText.length)}' at position ${oldText.length}`);
    }

    // Check if old text had extra characters that were removed
    if (oldText.length > newText.length) {
        differences.push(`➖ Removed: '${oldText.slice(newText.length)}' from position ${newText.length}`);
    }

    return differences.length ? differences : ["✅ No changes detected"];
}



self.onmessage = async function (event) {
    const { id, action, data } = event.data;

    try {
        //console.log(`Worker received action: ${action} for ID: ${id}`);

        switch (action) {

            case 'initEditor': {
                const decodedContent = new TextDecoder().decode(new Uint8Array(data.content));
                let saveContentInit = processContent(decodedContent);
                saveContentInit = saveContentInit.replace(/<link[^>]*?(\/all\.min\.css|style\.css|style-free\.css|\/greenlefttemplate\.css)"[^>]*?>/g, '');
                previousContent = saveContentInit;

                lastSavedHash = fastHash(saveContentInit);
                console.log(`Initializing editor hash for: ${data.filename}`);
                self.postMessage({ id, status: 'initialized', message: `Editor initialized with hash: ${lastSavedHash}` });
                break;
            }

            case 'processContent': {
                const decodedContent = new TextDecoder().decode(new Uint8Array(data.content));
                const processedContent = processContent(decodedContent);

                const encodedProcessedContent = new TextEncoder().encode(processedContent);
                self.postMessage({ id, status: 'processed', content: encodedProcessedContent.buffer }, [encodedProcessedContent.buffer]);
                break;
            }


            case 'processContentSave': {
                const decodedContent = new TextDecoder().decode(new Uint8Array(data.content));
                let processedSaveContent = processContent(decodedContent);
                processedSaveContent = processedSaveContent.replace(/<link[^>]*?(\/all\.min\.css|style\.css|style-free\.css|\/greenlefttemplate\.css)"[^>]*?>/g, '');

                const encodedProcessedSaveContent = new TextEncoder().encode(processedSaveContent);
                self.postMessage({ id, status: 'processed', content: encodedProcessedSaveContent.buffer }, [encodedProcessedSaveContent.buffer]);
                break;
            }

            case 'saveContent': {
                const decodedContent = new TextDecoder().decode(new Uint8Array(data.content));
                let saveContent = processContent(decodedContent);
                saveContent = saveContent.replace(/<link[^>]*?(\/all\.min\.css|style\.css|style-free\.css|\/greenlefttemplate\.css)"[^>]*?>/g, '');

                //This is not working so Commenting it out
                // //Generate hash for content comparison
                // const newHash = fastHash(saveContent);
                // //If content hasn't changed, do nothing
                // if (newHash === lastSavedHash) {
                //     console.log(`⚡ Content unchanged, skipping save for: ${data.filename}`);
                //     self.postMessage({ id, status: 'unchanged', message: `No changes detected for: ${data.filename}` });
                //     return;
                // }
                // lastSavedHash = newHash;
                // console.log('New Hash is:', newHash);

                const encodedSaveContent = new TextEncoder().encode(saveContent);
                saveContentToIndexedDB(id, data.filename, encodedSaveContent.buffer);
                break;
            }

            case 'getContent':
                getContentFromIndexedDB(id, data.filename);
                break;

            case 'renameFile':
                renameFileInIndexedDB(id, data.oldFilename, data.newFilename);
                break;

            case 'deleteContent':
                deleteContentFromIndexedDB(id, data.filename);
                break;

            case 'saveToLocalStorageSuccess': {
                console.log(`LocalStorage save successful for key: ${data.key}`);
                // Final response back to the main thread to resolve the original promise
                self.postMessage({ id, status: 'saved', key: data.key, lastUpdated: data.lastUpdated });
                break;
            }

            case 'saveToLocalStorageError': {
                console.error(`LocalStorage save failed for key: ${data.key}`);
                // Notify main thread of the failure
                self.postMessage({ id, status: 'error', message: data.message });
                break;
            }

            case 'getFromLocalStorageSuccess': {
                console.log(`Content retrieved from LocalStorage for key: ${data.key}`);
                self.postMessage({
                    id,
                    status: 'retrieved',
                    key: data.key,
                    content: data.content,
                    lastUpdated: data.lastUpdated
                });
                break;
            }

            case 'getFromLocalStorageNotFound': {
                console.log(`Content not found in LocalStorage for key: ${data.key}`);
                self.postMessage({
                    id,
                    status: 'not_found',
                    key: data.key
                });
                break;
            }

            case 'deleteFromLocalStorageSuccess': {
                console.log(`Content deleted from LocalStorage for key: ${data.key}`);
                self.postMessage({ id, status: 'deleted', key: data.key });
                break;
            }

            case 'deleteFromLocalStorageNotFound': {
                console.log(`Content not found in LocalStorage for key: ${data.key}`);
                self.postMessage({ id, status: 'not_found', key: data.key });
                break;
            }


            case 'terminateWorker':
                console.log("Terminatating worker");
                closeDatabase();
                self.close();
                self.postMessage({ id, status: 'terminated', message: 'Worker and IndexedDB connection closed.' });
                break;

            default:
                throw new Error(`Unknown action: ${action}`);
        }
    } catch (error) {
        console.log('Unhandled error in worker:', error.message);
        self.postMessage({ id, status: 'error', error: error.message });
    }
};

// Ensure database is closed when the worker is terminated
self.onclose = function () {
    closeDatabase();
};

// Initialize IndexedDB when the worker starts

initIndexedDB();
